export const TRIP_TOTAL_BREAKDOWN_TEXT = "Trip total";
